<template>
  <div class="timesheet-sidebar sidebar">
    <div class="member-filter">
      <form
        class="search-bar"
        action="javascript:void(0);"
      >
        <button
          type="submit"
          class="search-loop"
        >
          <i class="atto atto-search-loop" />
        </button>
        <input
          v-model="search"
          type="search"
          :placeholder="label.get('search')"
        >
      </form>
    </div>
    <div class="all-members">
      <b-dropdown
          ref="dropdown"
          class="filter-members timesheets-filter-members"
          variant="link"
          no-caret
      >
        <template slot="button-content">
          <div class="members-icon">
            <i class="atto atto-sidebar-team" />
          </div>
          <span class="filter-title">{{ dropdownName }} ({{ filteredMembers.length }}) </span>
          <i class="atto atto-caret-down-b"/>
        </template>
        <b-dropdown-item
            class="members-dropdown"
            @click="hideDropdown"
        >
          <i class="atto atto-sidebar-team" />
          <p>{{ dropdownName  }}</p>
          <i class="atto atto-caret-down-b"/>
        </b-dropdown-item>
        <b-dropdown-item  @click="onMemberSidebarChange(false)" to="/timesheets/all">
          {{ label.get('all_members') }}
        </b-dropdown-item>
        <b-dropdown-item @click="onMemberSidebarChange(true)" to="/timesheets/archived">
          {{label.get('archived_members')}}
        </b-dropdown-item>
      </b-dropdown>
      <perfect-scrollbar :options="{ wheelPropagation: false}">


       <!-- <div class="all-members-item">
          <router-link
            to="/timesheets/all"
            tag="a"
            class="router-wrap"
          >
            <div class="profile-pic">
              <i class="atto atto-team-light" />
            </div>
            <div class="name">
              <h4>{{ label.get('all_members') }}</h4>
            </div>
          &lt;!&ndash;<div class="arrow">
              <i class="atto atto-r-arrow-b" />
            </div>&ndash;&gt;
          </router-link>
        </div>-->

        <ul class="member-list">
          <li
            v-for="(member, idx) in filteredMembers"
            :key="idx"
          >
            <router-link :to="{ name: 'MemberTimesheets', params: { uid: member.uid }}">
              <div
                class="profile-pic"
                :class="{'no-avatar': !member.avatar}"
              >
                <span
                  v-if="!member.avatar"
                  class="initials"
                >
                  {{ member.initials }}
                </span>

                <img
                  v-if="member.avatar"
                  :src="member.avatar"
                  alt=""
                >
              </div>
              <div class="name">
                <h4>{{ member.name | truncate(40) }}</h4>
              </div>
            <!--  <div class="arrow">
                <i class="atto atto-r-arrow-b" />
              </div>-->
            </router-link>
          </li>
        </ul>
        <a
          href="javascript:void(0)"
          class="invite"
          @click="inviteMember"
        >
          <i class="atto atto-add-more" />
          <span>{{ label.get('invite_new_member') }}</span>
        </a>
      </perfect-scrollbar>
    </div>
    <transition name="fade">
      <span
        v-if="showOverlay"
        class="sidebar-overlay"
      />
    </transition>
  </div>
</template>

<script>

    import MemberService from "../../settings/services/MemberService";

    export default {
        name: "MembersSidebarComponent",
        filters: {
            truncate(value, stop) {
                return value.slice(0, stop) + (stop < value.length ? '...' : '');
            }
        },
        data(){
            return{
                search: '',
                members: this.$store.state.members,
                dropdownName : this.label.get('all_members')
            }
        },
        computed: {
            showOverlay(){
                return this.$store.state.overlay;
            },
          filteredMembers() {
            return this.members.filter((item) => {
              return item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
            });
          }
        },
        mounted() {
          if(this.$route.name !== undefined && this.$route.name === 'ArchivedMemberTimesheets') {
            this.onMemberSidebarChange(true);
          }
          this.$root.$on('onMemberSidebarChange', this.onMemberSidebarChange);

        },
        methods: {

            onMemberSidebarChange(archived = false) {
              if(archived) {
                this.getArchivedMembers()
              } else {
                this.allMembers()
              }
            },
            inviteMember: function () {
                this.$root.$emit('showInviteMembers');
            },
            hideDropdown() {
              this.$refs.dropdown.hide(true);
            },
            getArchivedMembers(){
              this.$store.state.showArchivedMembers = true;
              this.dropdownName = this.label.get('archived_members');
              if(this.$store.state.archivedMembers.length === 0) {
                this.$store.commit('showLoading');
                MemberService.getArchivedMembers().then((data) => {
                  this.members = data;
                  this.$store.state.archivedMembers = this.members;

                  this.$store.commit('hideLoading');
                }).catch(() => {
                  this.$store.commit('hideLoading');
                });
              } else {
                this.members = this.$store.state.archivedMembers;
              }

            },
            allMembers(){
              this.$store.state.showArchivedMembers = false;
              this.members = this.$store.state.members;
              this.dropdownName = this.label.get('all_members')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .sidebar{
      .member-filter{
        border-bottom: none;
        height: 60px;
        form{
          border: none;
          background-color: transparent;

          input[type=search]{
            background-color: transparent;
          }

          &:focus-within {
            button.search-loop {
              i {
                color: $atto-font-color;
              }
            }
          }
        }
      }
      .filter-members{
        width: 100%;
        .members-icon{
          width: 40px;
          height: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        i.atto-caret-down-b,
        i.atto-caret-down-b {
          font-size: 10px;
          color: #c9c9c9;
          margin-left: auto;
          margin-right: 8px;
        }

        i.atto-caret-down-b {
          margin-right: 13px;
        }
      }
    }
    .member-list{
      li {
        .profile-pic{
          width: 36px;
          max-width: 36px;
          min-width: 36px;
          height: 36px;
          margin-right: 12px;
          .initials{
          }
          img{
            max-width: 36px;
            min-width: 36px;
            width: 36px;
            height: 36px;
            image-rendering: -moz-crisp-edges;         /* Firefox */
            image-rendering:   -o-crisp-edges;         /* Opera */
            image-rendering: -webkit-optimize-contrast;/* Webkit (non-standard naming) */
            image-rendering: crisp-edges;
            -ms-interpolation-mode: nearest-neighbor;  /* IE (non-standard property) */
          }
        }
      }
    }
    button.invite i.atto,
    a.invite i.atto {
      margin: 0 18px 0 22px;
      font-size: 0.75rem;
    }


    div.all-members {

        .all-members-item{
            a{
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-start;
                padding: 12px 10px 12px 20px;
              /*  border-top: 1px solid #FFF;
                border-bottom: 1px solid #FFF;*/
                .profile-pic{
                    i{
                        &:before{
                            @include base-transition(ease color 0.1s)
                        }
                    }
                }
            }
            .profile-pic {
                width: 36px !important;
                min-width: 36px;
                max-width: 36px;
                height: 36px !important;
                border-radius: 100%;
                margin-right: 12px !important;
                justify-content: center;
                display: flex;
                align-items: center;

                img {
                    border-radius: 100%;
                }

                i {
                    font-size: 27px;
                }
            }

            .name {
                display: inline-flex;
                min-width: 160px;
                width: 22.2222%;
                margin-right: 20px;

                h4 {
                    font-family: $roboto-font;
                    font-weight: 400;
                }
            }

            .details {
                display: flex;
                align-items: center;
                width: 42.92%;
                min-width: 309px;

                * {
                    display: inline-flex;
                }

                i.activity-icon {
                    margin-left: 0;
                    width: 8px;
                    height: 8px;
                    -webkit-border-radius: 8px;
                    -moz-border-radius: 8px;
                    border-radius: 8px;
                }

                .activity-info,
                .status-label {
                    font-size: 0.875rem;
                    font-family: $roboto-font;
                    font-weight: 400;
                }

                .activity-info::before {
                    content: '';
                }
            }

            .arrow {
                margin-left: auto;
                width: 24px;
                height: 24px;
                justify-content: center;
                display: inline-flex;
                align-items: center;

                i {
                    font-size: 14px;
                    color: #C7C7C7;
                }
            }
        }
        .ps{
            max-height: calc(100vh - 172px);
            .ps__rail-y{
                width: 16px;
                opacity: 0;
                z-index: 2;
                &:hover{
                    background-color: transparent;
                    .ps__thumb-y{
                        width: 8px;
                        background-color: rgba(239,239,239,1);
                    }
                }
                &.ps--clicking{
                    background-color: transparent;
                }
            }
            .ps__thumb-y{
                right: 4px;
                width: 8px;
                opacity: 1;
                background-color: rgba(239,239,239,0.5);
            }

            &:hover{
                .ps__rail-y{
                    opacity: 1;
                }
            }

        }
    }
    .timesheets-filter-members .dropdown-menu{
      margin: -55px 0 0 0px;
    }
</style>

<style lang="scss">
  .timesheets-filter-members{
    .dropdown-toggle {
      display: inline-flex !important;
      align-items: center !important;
      background-color: transparent !important;
      padding: 5px !important;
      width: 200px !important;
      position: relative !important;
      margin-left: 18px !important;
      cursor: pointer !important;
      border-radius: 0 !important;
      @include base-transition(ease all 0.15s);

      .members-icon{
        .atto-sidebar-team{
          &:before{
            content: "";
            display: flex;
            width: 30px;
            height: 21px;
            background: url("../../../../../assets/images/sidebar-team.svg") no-repeat;
            margin-right: 15px;
          }
        }
      }

      span.filter-title {
        color: $atto-font-color;
        font: $roboto-regular 0.9375rem/1.5625rem $roboto-font;
      }

      &:hover {
        text-decoration: none;
      }

      &:focus,
      &:active,
      &:active:focus {
        text-decoration: none;
      }


    }
    .dropdown-menu {
      border: 0;
      position: absolute;
      top: -8px;
      left: 0;
      width: 305px;
      box-shadow: 0 0 10px 0 rgba(38, 38, 38, 0.15);
      background-color: #fff;
      border-radius: 0;
      padding: 0 0 8px 0;
      margin: -57px 0 0 -1px;

      li.members-dropdown {
        a {
          display: flex;
          flex-direction: row;
          padding: 16px 8px;
          align-items: center;
          border-bottom: 2px solid #efefef;
          margin-bottom: 8px;

          .atto-sidebar-team{
            width: 41px;
            &:before{
              content: "";
              display: flex;
              width: 30px;
              height: 21px;
              background: url("../../../../../assets/images/sidebar-team.svg") no-repeat;
              margin-right: 15px;
            }
          }

          p {
            flex-grow: 1;
            margin-bottom: 0;
            font-size: 0.875rem;
            line-height: 1.5rem;
            font-family: $roboto-font;
            color: $atto-font-color;
            font-weight: 500;
          }

          i.atto-caret-down-b{
            margin-right: 8px;
          }
          &:hover {
            background-color: transparent;
          }
        }

      }

      li {
        display: flex;
        padding: 0;

        a {
          padding: 8px 8px 8px 49px;
          font-size: 0.875rem;
          line-height: 1.5rem;
          font-family: $roboto-font;
          color: $atto-font-color;
          font-weight: 500;
          width: 100%;
          cursor: pointer;
          display: flex;
          align-items: center;

          &:hover {
            background-color: #F7F7F7;
          }

          i.activity-icon {
            width: 4px;
            height: 4px;
            margin: 0 10px;
          }
        }
      }
    }
  }
</style>


